<template>
  <div v-if="leaseInfo && Object.values(leaseInfo).length && leaseInfo.title">
    <new-common-banner title="" :icon="icon" @ensureClick="leaseClick">
      <div class="process-item">
        <div class="item_address">
          <span class="title">{{ leaseInfo.title }}</span>
        </div>
        <div class="item_info">{{ leaseInfo.content }}</div>
      </div>
    </new-common-banner>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from '@vue/composition-api'
import newCommonBanner from '@/components/new-common-banner.vue'
import { skipToUrl } from '@utils/native'
import { login } from '@/lib/decorator/login'
import { useDecorator } from '@/lib/useDecorator'
import { getQueryString } from '@utils/index'
import { getLeaseJumpUrl } from '@/apis'
import { state } from '@/store/index'
import { cookie } from '@zz-common/zz-utils'

export default defineComponent({
  components: {
    newCommonBanner
  },
  props: {
    leaseInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, ctx) {
    const { $tiktok } = ctx.root
    const icon = ref(
      'https://pic3.zhuanstatic.com/zhuanzh/e4cd2bd3-9129-4130-8aea-5d9f7177000d.png'
    )
    $tiktok('create', 'lease-info')
    onMounted(() => {
      $tiktok('mounted', 'lease-info')
    })

    // $ 跳转租赁地址
    let rentUrl = ''
    const leaseClick = useDecorator(async () => {
      if (!rentUrl) {
        // $ 查询租赁入口链接
        const infoId = getQueryString('infoId') || state.infoId
        if (!infoId || infoId === '') return // 如果infoId的值不存在，则直接返回
        const PPU = cookie.get('PPU')
        const zljToken = `PPU="${PPU}"`
        const data = await getLeaseJumpUrl({
          request: JSON.stringify({ productInfoId: infoId, inputTag: 1, zljToken })
        })
        rentUrl = data.data.jumpUrl
      }
      skipToUrl({
        targetUrl: rentUrl
      })
    }, login)

    return { leaseClick, icon }
  }
})
</script>
